// extracted by mini-css-extract-plugin
export var cardLayout = "_8e-1";
export var paginationContainer = "_8e-0";